import { render, staticRenderFns } from "./kita-show.vue?vue&type=template&id=687d2171&"
import script from "./kita-show.vue?vue&type=script&lang=js&"
export * from "./kita-show.vue?vue&type=script&lang=js&"
import style0 from "./kita-show.vue?vue&type=style&index=0&id=687d2171&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports